export default "__VITE_ASSET__CXnr55$2__"